import {
  Box,
  Button,
  ButtonGroup,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Grid,
  IconButton,
  MenuItem,
  Stack,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tabs,
  TextField,
  Typography,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import FileDownloadRoundedIcon from '@mui/icons-material/FileDownloadRounded';
import { ChangeEvent, useEffect, useState, Dispatch } from 'react';
import { useQuery, useQueryClient } from 'react-query';
import { useSession, xapi } from '../../hooks/session';
import SwLoading from './spinner/SwLoading';
import mapPinIcon from '../../images/sub/map_pin.svg';
import openBookIcon from '../../images/sub/open_book.svg';
import walkingManIcon from '../../images/sub/waking_man.svg';
import {
  KEY_CLASS,
  KEY_EDUCATION_OFFICE,
  KEY_PORTAL,
  KEY_SCHOOL,
  KEY_USER_READ_LIST,
  KEY_USER_STEP_LIST,
  KEY_USER_WRITE_LIST,
} from '../../common/key';

import {
  commaFormat,
  convert2Date,
  DATE_LOCALE_OFFSET,
  encodeSearchWord,
  firstDayOfMonth,
  formatDateString,
  getCurrentStartDate,
  lastDayOfMonth,
} from '../../common/helper';
import {
  getUserReadList,
  getUserStepList,
  getUserWriteList,
} from '../../common/api/ApiUser';
import { SwSelectMonth } from './SwSelectMonth';
import NoDataPage from './NoDataPage';
import { EmptyPage } from './EmptyPage';
import { SwPagination } from './tableElement/SwPagination';

const DEFAULT_WIDTH = '4rem';

interface Props {
  type: string;
  writeInfo: any;
}

export const SwUserWriteCard: React.FC<Props> = ({ type, writeInfo }) => {
  const { loginVal } = useSession();
  const queryClient = useQueryClient();
  const [requestList, setRequestList] = useState<any>([]);
  const [bookSeq, setBookSeq] = useState<number>(-1);
  const [tabValue, setTabValue] = useState<number>(0);
  const [readType, setReadType] = useState<string>('like');
  const [writeItem, setWriteItem] = useState<string>('0');
  const [targetMonth, setTargetMonth] = useState<any>(getCurrentStartDate());
  const [loading, setLoading] = useState<any>(false);
  const [searchKey, setSearchKey] = useState<string>('read');
  const [searchWord, setSearchWord] = useState<string>('');
  const rowsPerPageOptions = [5, 10, 15, 20];
  const [writePage, setWritePage] = useState(1);
  const [stepPage, setStepPage] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [stepRowsPerPage, setStepRowsPerPage] = useState(10);
  const [description, setDescription] = useState<string>(
    '텍스트가 이곳에 나옵니다. 텍스트가 이곳에 나옵니다. 텍스트가 이곳에 나옵니다.텍스트가 이곳에 나옵니다.텍스트가 이곳에 나옵니다.텍스트가 이곳에 나옵니다.텍스트가 이곳에 나옵니다.텍스트가 이곳에 나옵니다.텍스트가 이곳에 나옵니다.텍스트가 이곳에 나옵니다.텍스트가 이곳에 나옵니다.텍스트가 이곳에 나옵니다.텍스트가 이곳에 나옵니다.텍스트가 이곳에 나옵니다.텍스트가 이곳에 나옵니다.텍스트가 이곳에 나옵니다.텍스트가 이곳에 나옵니다.텍스트가 이곳에 나옵니다.텍스트가 이곳에 나옵니다.텍스트가 이곳에 나옵니다.텍스트가 이곳에 나옵니다.텍스트가 이곳에 나옵니다.텍스트가 이곳에 나옵니다.텍스트가 이곳에 나옵니다.텍스트가 이곳에 나옵니다.텍스트가 이곳에 나옵니다.텍스트가 이곳에 나옵니다.텍스트가 이곳에 나옵니다.텍스트가 이곳에 나옵니다.텍스트가 이곳에 나옵니다.텍스트가 이곳에 나옵니다.텍스트가 이곳에 나옵니다.텍스트가 이곳에 나옵니다.나옵니다.텍스트가 이곳에 나옵니다.나옵니다.텍스트가 이곳에 나옵니다.나옵니다.텍스트가 이곳에 나옵'
  );

  return (
    <>
      <Box
        sx={{
          mt: 2,
          borderRadius: '1rem', // 둥근 모서리
          boxShadow: 2, // 그림자 효과
          p: 2, // 내부 여백
          bgcolor: '#f9f9f9', // 배경색 (선택)
          width: '100%',
          height: '22rem',
        }}
      >
        <Box>
          {(type === KEY_EDUCATION_OFFICE ||
            type === KEY_PORTAL ||
            type === KEY_SCHOOL) && (
            <Typography className=''>{`${writeInfo.officeName}/${writeInfo.schoolName}`}</Typography>
          )}
        </Box>
        <Box className='flex_between'>
          <Typography className='title'>
            {type === KEY_SCHOOL
              ? `${writeInfo.schoolGrade}학년${writeInfo.schoolClass}반 : ${writeInfo.nickname}`
              : type === KEY_CLASS
              ? `${writeInfo.nickname}`
              : type === KEY_EDUCATION_OFFICE
              ? `${writeInfo.schoolGrade}학년${writeInfo.schoolClass}반 : ${writeInfo.nickname}`
              : `${writeInfo.schoolGrade}학년${writeInfo.schoolClass}반 : ${writeInfo.nickname}`}
          </Typography>
          <Typography className='title'>
            {convert2Date(writeInfo.writeDate, writeInfo.writeTime)}{' '}
            {writeInfo.emotion !== null && writeInfo.emotion !== undefined && (
              <span>
                {String.fromCodePoint(Number(`0x${writeInfo.emotion}`))}
              </span>
            )}
          </Typography>
        </Box>
        <Divider sx={{ m: 0, p: 0 }} />
        <Box className='flex_start' sx={{ mb: '1rem' }}>
          <Box sx={{ width: '50%', height: '20vh' }}>
            <TextField
              sx={{
                width: '20vw',
                '& .MuiOutlinedInput-root': {
                  height: 'auto',
                },
              }}
              rows={7}
              aria-hidden='true'
              multiline
              value={writeInfo.bodyText ?? ''}
            />
          </Box>
          <Box
            sx={{
              width: '50%',
              height: '20vh',
              ml: '.5rem',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              bgcolor: '#f5f5f5', // 선택적으로 배경색 추가 가능
              border: '1px solid #ccc', // ✅ 테두리 추가
              borderRadius: '8px', // 선택: 모서리 둥글게
            }}
          >
            {writeInfo.resourceList !== undefined &&
            writeInfo.resourceList.length > 0 ? (
              <img
                src={`${loginVal.value.user.cloudFront}/diary/${writeInfo.resourceList[0].resourceUrl}`}
                alt='id'
                height='80%'
              />
            ) : (
              <Typography sx={{ color: '#999' }}>이미지 없음</Typography>
            )}
          </Box>
        </Box>
        <Box className='flex_start' sx={{ mb: '0rem' }}>
          {writeInfo.bookTitle && (
            <Box sx={{ width: '15rem', mr: '.5rem' }}>
              <Chip
                icon={<img src={openBookIcon} alt='map_pin' />}
                label={writeInfo.bookTitle}
                sx={{
                  height: 'auto',
                  '& .MuiChip-label': {
                    display: 'block',
                    whiteSpace: 'normal',
                  },
                }}
                variant='outlined'
              />
            </Box>
          )}
          {writeInfo.step > 0 && (
            <Box sx={{ width: '15rem' }}>
              <Chip
                icon={<img src={walkingManIcon} alt='map_pin' />}
                label={writeInfo.step > 0 ? commaFormat(writeInfo.step) : ''}
                sx={{
                  height: '2.75rem',
                  '& .MuiChip-label': {
                    display: 'block',
                    whiteSpace: 'normal',
                  },
                }}
                variant='outlined'
              />
            </Box>
          )}
        </Box>
        <Typography className='title'>
          {writeInfo.tagList &&
            writeInfo.tagList.map((item: any) => <span>#{item.tagName}</span>)}
        </Typography>
      </Box>
    </>
  );
};
